<template>
  <a-flex wrap="wrap" gap="small">
    <template v-if="groupData.group_1">
      <a-tag>
        {{ groupData.group_1.name }}
      </a-tag>

      <a-tag v-if="hasCount(groupData.group_1.count)">
        {{ groupData.group_1.count + ' ' + getWordFormBasedOnTheCount(groupData.group_1.count, 'сотрудник', 'сотрудника', 'сотрудников') }}
      </a-tag>
    </template>

    <template v-if="groupData.group_2">
      <a-tag>
        {{ groupData.group_2.name }}
      </a-tag>

      <a-tag v-if="hasCount(groupData.group_2.count)">
        {{ groupData.group_2.count + ' ' + getWordFormBasedOnTheCount(groupData.group_2.count, 'сотрудник', 'сотрудника', 'сотрудников') }}
      </a-tag>
    </template>
  </a-flex>
</template>

<script>
  import {useStore} from "vuex";
  import {computed} from "@vue/reactivity";
  import {getWordFormBasedOnTheCount} from "@/views/Report/utils";

  export default {
    name: 'analytics-groups-tags',
    methods: {
      getWordFormBasedOnTheCount,
      hasCount(count) {
        return count !== null && count !== undefined && count !== ''
      },
    },

    setup() {
      const store = useStore();
      const groupData = computed(() => store.state.group.analyticsGroupData);

      return {
        groupData,
      }
    }
  }
</script>
